import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
/**
 * Authentication errors for email update.
 */
export var SetEmailErrorCodeV1;
(function (SetEmailErrorCodeV1) {
    /**
     * The email provided is invalid.
     */
    SetEmailErrorCodeV1[SetEmailErrorCodeV1["InvalidEmail"] = 30009] = "InvalidEmail";
    /**
     * Incorrect member password provided.
     */
    SetEmailErrorCodeV1[SetEmailErrorCodeV1["InvalidCurrentPassword"] = 30013] = "InvalidCurrentPassword";
    /**
     * The email provided is already registered.
     */
    SetEmailErrorCodeV1[SetEmailErrorCodeV1["EmailAlreadyRegistered"] = 30014] = "EmailAlreadyRegistered";
})(SetEmailErrorCodeV1 || (SetEmailErrorCodeV1 = {}));
export class SetEmailErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to update email. API error code ${errorCode}: ${SetEmailErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getSetEmailErrorV1(error) {
    const errorCode = await getResponseErrorCode(error);
    return errorCode && Object.values(SetEmailErrorCodeV1).includes(errorCode) ? new SetEmailErrorV1(errorCode) : error;
}
//# sourceMappingURL=set-email-error.js.map